import { render, staticRenderFns } from "./popularExams.vue?vue&type=template&id=22e6fede&scoped=true&"
import script from "./popularExams.vue?vue&type=script&lang=js&"
export * from "./popularExams.vue?vue&type=script&lang=js&"
import style0 from "./popularExams.vue?vue&type=style&index=0&id=22e6fede&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e6fede",
  null
  
)

export default component.exports